import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function index() {
  const axios = axiosInstance().primoLab;
  let materials = [];

  await axios
    .get("/materials")
    .then(async (response) => {
      materials = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { materials };
}
